import emptyContent   from "./wrapper/urDataGridContentEmpty.vue";
import dNormalContent from "./wrapper/urDataGridContentNormal.vue";
import fNormalContent from "./wrapper/urFullGridContentNormal.vue";
import dInfContent    from "./wrapper/urDataGridContentInfinity.vue";
import fInfContent    from "./wrapper/urFullGridContentInfinity.vue";
import fGroupContent  from "./wrapper/urFullGridContentGrouping.vue";
import dGroupContent  from "./wrapper/urDataGridContentGrouping.vue";
import fGInfContent   from "./wrapper/urFullGridContentGroupInfi.vue";
import dGInfContent   from "./wrapper/urDataGridContentGroupInfi.vue";

export default {
    name : 'urDataGridContent',
    inject : ['gridInfo'],
    functional : true,
    render(h, {injections}) {
        const gInfo = injections.gridInfo;
        var grps    = gInfo.opts.grouping,
            isInf   = gInfo.opts.infinityScroll,
            isEmpty = !gInfo.vars_viewSize,
            isFull  = gInfo.full,
            isGroup = Array.isArray(grps) && grps.length;
        var compo = null;
        if(isEmpty) {
            compo = emptyContent;
        } else if(isGroup) {
            // group something...
            if(isInf) {
                compo = isFull ? fGInfContent  : dGInfContent;
            } else {
                compo = isFull ? fGroupContent : dGroupContent;
            }
        } else {
            // Normal grid
            if(isInf) {
                compo = isFull ? fInfContent    : dInfContent;
            } else {
                compo = isFull ? fNormalContent : dNormalContent;
            }
        }
        return h(compo);
    }
}
